import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Interval } from '../../shared/booking/model/schedule-appointment.model';
import { ListIntervals } from '../../shared/booking/model/schedule-appointment.model';
import { SERVER_API_URL } from '../../app.constants';
import { Reservation } from '../../shared/booking/model/reservation.model';

type EntityResponseType = HttpResponse<ListIntervals>;

@Injectable({ providedIn: 'root' })
export class ScheduleAppointmentService {
  public resourceUrl = SERVER_API_URL + 'api/freeResourceForPeriod';
  public reservationForPeriodUrl = SERVER_API_URL + 'api/freeResourceForPeriodAndDays';
  public reservationUrl = SERVER_API_URL + 'api/reservations';

  constructor(protected http: HttpClient) {}

  getFreeResources(
    utilitiesId: number[],
    resourceId: number,
    startDate: Date,
    endDate: Date
  ): Observable<EntityResponseType> {
    return this.http.post<ListIntervals>(
      `${this.resourceUrl}/${resourceId}/${startDate.getTime()}/${endDate.getTime()}`,
      utilitiesId,
      {
        observe: 'response',
      }
    );
  }

  getFreeWithoutResource(
    utilitiesId: number[],
    startDate: Date,
    endDate: Date
  ): Observable<HttpResponse<Interval[]>> {
    return this.http.post<Interval[]>(
      `${SERVER_API_URL}api/resourceAvailabilityForPeriod/${startDate.getTime()}/${endDate.getTime()}`,
      utilitiesId,
      {
        observe: 'response',
      }
    );
  }

  getFreeResourcesForDays(
    utilityId: number,
    resourceId: number,
    startDate: Date,
    endDate: Date,
    days: number[]
  ): Observable<EntityResponseType> {
    return this.http.post<ListIntervals>(
      `${this.reservationForPeriodUrl}/${utilityId}/${resourceId}/${startDate.getTime()}/${endDate.getTime()}`,
      days,
      {
        observe: 'response',
      }
    );
  }

  getFreeWithoutResourceForDays(
    utilityId: number,
    startDate: Date,
    endDate: Date,
    days: number[]
  ): Observable<HttpResponse<Interval[]>> {
    return this.http.post<Interval[]>(
      `api/resourceAvailabilityForPeriodAndDays/${utilityId}/${startDate.getTime()}/${endDate.getTime()}`,
      days,
      {
        observe: 'response',
      }
    );
  }

  getReservationsByReservationNumber(
    reservationNumber: number | string
  ): Observable<HttpResponse<Reservation[]>> {
    return this.http.get<Reservation[]>(
      `${this.reservationUrl}ByReservationNumber/${reservationNumber}/`,
      {
        observe: 'response',
      }
    );
  }

  getReservationsByIds(ids: number[]): Observable<HttpResponse<Reservation[]>> {
    return this.http.post<Reservation[]>(
      `${this.reservationUrl}ByIds`,
      ids, // šaljemo listu ID-jeva u body
      { observe: 'response' }
    );
  }

  confirmReservation(reservationNumber: number): Observable<number> {
    return this.http.post<number>(`${this.reservationUrl}-confirm/${reservationNumber}/`, {
      observe: 'response',
    });
  }
}
